import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.props.varios)
      ? (_openBlock(), _createBlock(_component_a_select, {
          key: 0,
          ref: "refSelecionarProduto",
          class: _normalizeClass('ss-tamanho-completo ' + _ctx.props.classCss),
          value: _ctx.computedCodigosSelecionados,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.computedCodigosSelecionados) = $event)),
          "show-search": "",
          mode: "multiple",
          allowClear: _ctx.props.limparSelecao,
          placeholder: _ctx.props.placeholder,
          optionFilterProp: "label",
          filterOption: false,
          "not-found-content": _ctx.state.buscandoDados ? undefined : null,
          options: _ctx.state.listaProdutos,
          disabled: _ctx.props.disabled,
          title: _ctx.props.title,
          "data-coluna": _ctx.props.dataAttributeColuna,
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeVarios($event))),
          onSearch: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pesquisarProduto($event))),
          onBlur: _ctx.blur,
          onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.pesquisarProduto('')))
        }, _createSlots({
          option: _withCtx(({ label }) => [
            _createVNode(_component_a_tooltip, {
              title: label,
              placement: "right"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(label), 1)
              ]),
              _: 2
            }, 1032, ["title"])
          ]),
          _: 2
        }, [
          (_ctx.state.buscandoDados)
            ? {
                name: "notFoundContent",
                fn: _withCtx(() => [
                  _createTextVNode(" Buscando Produtos "),
                  _createVNode(_component_a_spin)
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["class", "value", "allowClear", "placeholder", "not-found-content", "options", "disabled", "title", "data-coluna", "onBlur"]))
      : (_openBlock(), _createBlock(_component_a_select, {
          key: 1,
          style: {"vertical-align":"middle"},
          ref: "refSelecionarProduto",
          class: _normalizeClass('ss-tamanho-completo ' + _ctx.props.classCss),
          value: _ctx.computedCodigoSelecionado,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.computedCodigoSelecionado) = $event)),
          "show-search": "",
          allowClear: _ctx.props.limparSelecao,
          placeholder: _ctx.props.placeholder,
          optionFilterProp: "label",
          filterOption: false,
          "not-found-content": _ctx.state.buscandoDados ? undefined : null,
          options: _ctx.state.listaProdutos,
          disabled: _ctx.props.disabled,
          title: _ctx.props.title,
          "data-coluna": _ctx.props.dataAttributeColuna,
          onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.change($event))),
          onSearch: _cache[6] || (_cache[6] = ($event: any) => (_ctx.pesquisarProduto($event))),
          onBlur: _ctx.blur,
          onFocus: _cache[7] || (_cache[7] = ($event: any) => (_ctx.pesquisarProduto('')))
        }, _createSlots({
          option: _withCtx(({ label }) => [
            _createVNode(_component_a_tooltip, null, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(label), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, [
          (_ctx.state.buscandoDados)
            ? {
                name: "notFoundContent",
                fn: _withCtx(() => [
                  _createTextVNode(" Buscando Produtos "),
                  _createVNode(_component_a_spin)
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["class", "value", "allowClear", "placeholder", "not-found-content", "options", "disabled", "title", "data-coluna", "onBlur"]))
  ]))
}